import "./Sidebar.css";
import {
  FaPowerOff,
  FaSchool,
  FaUserGraduate,
  FaTh,
  FaListAlt,
  FaCheckSquare,
  FaBookOpen,
  FaCog,
  FaCalendarTimes,
  FaChalkboard,
  FaMoneyBillAlt,
  FaUsers,
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { useContext } from "react";

// hooks
import { AuthContext } from "../../screens/Root/ProtectedRoute";
import { empty, isString } from "../../Utilities/utils";
// images
import appLogo from "../../assets/logo/blue-logo.png";

const Sidebar = ({ sidebarOpen, toggleSidebar }) => {
  const { user } = useContext(AuthContext);
  const userAvatar = !empty(user) && !empty(user.avatar) ? user.avatar : "";
  const fullName =
    !empty(user) && !empty(user.fullName) && isString(user.fullName)
      ? user.fullName.toUpperCase()
      : "";
  const title =
    !empty(user) && !empty(user.title) && isString(user.title)
      ? user.title.toUpperCase()
      : "";
  const schoolAvatar =
    !empty(user.schoolData) && !empty(user.schoolData.schoolAvatar)
      ? user.schoolData.schoolAvatar
      : "";
  const sessionTitle =
    !empty(user.schoolData) && !empty(user.schoolData.currentSessionTitle)
      ? user.schoolData.currentSessionTitle
      : "";
  const termTitle =
    !empty(user.schoolData) && !empty(user.schoolData.currentTermTitle)
      ? user.schoolData.currentTermTitle
      : "";
  const reverseSidebar = () => {
    toggleSidebar();
  };

  return (
    <div className={sidebarOpen ? "sidebar_responsive" : ""} id="sidebar">
      <div className="sidebar_title">
        <div
          className="flex flex-center direction-column align-center"
          style={{ width: "100%", marginTop: 40, marginBottom: 10 }}
        >
          <img
            className="sidebar-header-image"
            src={
              !empty(userAvatar)
                ? userAvatar
                : !empty(schoolAvatar)
                ? schoolAvatar
                : appLogo
            }
            alt="logo"
          />
          <p className="text-black text-center">
            <span>
              {title} {fullName} <br />
              (Student)
            </span>
            <br />
            <span>
              {sessionTitle} | {termTitle}
            </span>
          </p>
        </div>
      </div>

      <div className="sidebar_menu">
        {/* sidebar link */}
        <div className="separator">Home</div>
        <NavLink
          onClick={() => reverseSidebar()}
          to="/dashboard"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div
              className={
                isActive ? "sidebar_link active_menu_link" : "sidebar_link"
              }
            >
              <FaTh className="sidebar_link_icon" />
              <span className="sidebar_link_text">Dashboard</span>
            </div>
          )}
        </NavLink>

        <div className="separator">Users</div>
        {/* sidebar link */}
        <NavLink
          onClick={() => reverseSidebar()}
          to="/classmates"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div
              className={
                isActive ? "sidebar_link active_menu_link" : "sidebar_link"
              }
            >
              <FaUserGraduate className="sidebar_link_icon" />
              <div className="sidebar_link_text">Classmates</div>
            </div>
          )}
        </NavLink>

        {/* sidebar link */}
        <NavLink
          onClick={() => reverseSidebar()}
          // to="/parent"
          to="#"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div className={isActive ? "sidebar_link" : "sidebar_link"}>
              <FaUsers className="sidebar_link_icon" />
              <div className="sidebar_link_text">
                Parent
                <span className="coming-soon">&nbsp;&nbsp;Coming soon</span>
              </div>
            </div>
          )}
        </NavLink>

        <div className="separator">Academics</div>
        <NavLink
          onClick={() => reverseSidebar()}
          to="/class-details"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div className={isActive ? "sidebar_link" : "sidebar_link"}>
              <FaSchool className="sidebar_link_icon" />
              <div className="sidebar_link_text">Class Details</div>
            </div>
          )}
        </NavLink>
        <NavLink
          onClick={() => reverseSidebar()}
          // to="/time-table"
          to="#"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div className={isActive ? "sidebar_link" : "sidebar_link"}>
              <FaCalendarTimes className="sidebar_link_icon" />
              <div className="sidebar_link_text">
                Time Table
                <span className="coming-soon">&nbsp;&nbsp;Coming soon</span>
              </div>
            </div>
          )}
        </NavLink>
        <NavLink
          onClick={() => reverseSidebar()}
          // to="/blackboard"
          to="#"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div className={isActive ? "sidebar_link" : "sidebar_link"}>
              <FaChalkboard className="sidebar_link_icon" />
              <div className="sidebar_link_text">
                Blackboard
                <span className="coming-soon">&nbsp;&nbsp;Coming soon</span>
              </div>
            </div>
          )}
        </NavLink>

        <div className="separator">Assessment</div>
        <NavLink
          onClick={() => reverseSidebar()}
          to="/result-checker"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div
              className={
                isActive ? "sidebar_link active_menu_link" : "sidebar_link"
              }
            >
              <FaCheckSquare className="sidebar_link_icon" />
              <div className="sidebar_link_text">Result Checker</div>
            </div>
          )}
        </NavLink>
        <NavLink
          onClick={() => reverseSidebar()}
          to="/assessment"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div
              className={
                isActive ? "sidebar_link active_menu_link" : "sidebar_link"
              }
            >
              <FaCheckSquare className="sidebar_link_icon" />
              <div className="sidebar_link_text">Assessment</div>
            </div>
          )}
        </NavLink>
        <div className="separator">Finance</div>
        <NavLink
          onClick={() => reverseSidebar()}
          // to="/finance"
          to="#"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div className={isActive ? "sidebar_link" : "sidebar_link"}>
              <FaMoneyBillAlt className="sidebar_link_icon" />
              <div className="sidebar_link_text">
                Finance
                <span className="coming-soon">&nbsp;&nbsp;Coming soon</span>
              </div>
            </div>
          )}
        </NavLink>
        <div className="separator">Settings</div>
        <NavLink
          onClick={() => reverseSidebar()}
          to="/settings"
          style={{ textDecoration: "none" }}
        >
          {({ isActive }) => (
            <div
              className={
                isActive ? "sidebar_link active_menu_link" : "sidebar_link"
              }
            >
              <FaCog className="sidebar_link_icon" />
              <div className="sidebar_link_text">Settings</div>
            </div>
          )}
        </NavLink>

        {/* sidebar link */}
        <div className="sidebar_logout mb-20">
          <FaPowerOff className="sidebar_logout_icon" />
          <NavLink to="/logout" className="sidebar_logout_text">
            Logout
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
